import React from 'react';

const SubCategoryCardShimmer = () => {
  return (
    <div className="d-flex flex-column gap-2 py-1">
      <div className="d-flex gap-2">
        {[1, 2, 3, 4, 5, 6, 7].map((_, index) => (
          <div
            key={index}
            className="cr-cat-chip cr-shimmer-card"
            style={{ pointerEvents: 'none' }}
          >
            <div
              className="cr-shimmer-block rounded-circle"
              style={{ width: '38px', height: '38px', flexShrink: 0 }}
            />
            <div className="d-flex flex-column gap-1">
              <div
                className="cr-shimmer-block rounded"
                style={{ width: '90px', height: '12px' }}
              />
              <div
                className="cr-shimmer-block rounded"
                style={{ width: '55px', height: '10px' }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="d-flex gap-2">
        {[1, 2, 3, 4, 5, 6, 7].map((_, index) => (
          <div
            key={index}
            className="cr-cat-chip cr-shimmer-card"
            style={{ pointerEvents: 'none' }}
          >
            <div
              className="cr-shimmer-block rounded-circle"
              style={{ width: '38px', height: '38px', flexShrink: 0 }}
            />
            <div className="d-flex flex-column gap-1">
              <div
                className="cr-shimmer-block rounded"
                style={{ width: '80px', height: '12px' }}
              />
              <div
                className="cr-shimmer-block rounded"
                style={{ width: '50px', height: '10px' }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SubCategoryCardShimmer);